import { Injectable } from "@angular/core";
import { Subject } from "rxjs";

@Injectable({
    providedIn: 'root'
})
export class CommunicationService {
    private refreshComponentSubject = new Subject<void>();

    getRefreshComponent() {
        return this.refreshComponentSubject.asObservable();
    }

    triggerComponentRefresh() {
        this.refreshComponentSubject.next();
    }
}